import React, { Component } from 'react';
import UIComponent from 'components/UiComponent';
import './widget.less';
import authService from 'services/authService';
import AppContext from 'components/appContext';

class Widget extends Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="smart-widget shadow-depth-1">
                <UIComponent
                    component="view"
                    title={this.props.title}
                    name={this.props.name}
                    url={this.props.url + '/' + this.props.id}
                    urlParams={{
                        auth_token: authService.getToken(),
                        user_role: this.context.userDetails.CURRENT_ROLE,
                    }}
                />
            </div>
        )
    }

}

export default Widget;